<template>
  <Intro :labelAndDescColor="customColor"/>
  <Teleconsultations />
  <HowItWorks />
  <Question />
  <ContactUs />
</template>

<script setup lang="ts">
import Intro from "@/components/telemedicine/TelemedicineIntro.vue";
import Teleconsultations from "@/components/telemedicine/Teleconsultations.vue";
import HowItWorks from "@/components/telemedicine/HowItWorks.vue";
import Question from "@/components/telemedicine/Question.vue";
import ContactUs from "@/components/shared/footer/ContactUs.vue";
import { useRoute } from "vue-router";

import { computed, onMounted, ref, toRefs } from "vue";

const route = useRoute();

onMounted(async () => {
  //debugger;
  // window.scrollTo(0, 0);
});

const customColor = computed(() => {
  return route.meta.color || '#7BA7D8';
});
</script>

